<div *ngIf="loading" class="has-text-centered">
    <button class="button is-loading"></button>
</div>
<ng-container *ngIf="!loading">
    <div *ngIf="nextDeliveryTours.length > 0" class="content mb-0">
        <p>
            <b class="is-block mb-2">Nächste
                <span *ngIf="(selectedDeliveryTour?.nameDeliveryDates?.length ?? 0) > 0" >{{selectedDeliveryTour?.nameDeliveryDates}}</span>
                <span *ngIf="(selectedDeliveryTour?.nameDeliveryDates?.length ?? 0) == 0" >Liefertage</span>
                :</b>
            <ng-container *ngFor="let dt of nextDeliveryTours">
                {{dt.date | date:'EEEE':'+01:00':'de-DE'}}, den {{dt.date | date:'dd.LL.yyyy':'+01:00':'de-DE'}} <br>
                <span class="tag is-light mr-1 mt-1" *ngFor="let period of dt.periods">{{period}}</span><br *ngIf="dt.periods.length > 0">
            </ng-container>
            <br>
            Weitere Termine in der Zukunft<br> stehen Ihnen in der Kasse zur Verfügung.
        </p>
    </div>
</ng-container>
